export const SUCCESS_MODAL_TIMEOUT =  1500;
export const SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT = 500;
export const MAX_FILE_SIZE = 5242880; // 5MB in bytes

window.constants = {
	SUCCESS_MODAL_TIMEOUT,
  SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,
  MAX_FILE_SIZE
};



// WEBPACK FOOTER //
// ./src/constants/index.js